import React from "react";
import { Accordion, Card, CardBody, Col, Row } from "react-bootstrap";
import { float2moeda } from "../utils/Funcoes";

const AcordionServicos = ({ tiposServicos, handleClickAgendar }) => {

  return (
    <Accordion>

      {tiposServicos?.map((item, index) => (
        <Accordion.Item eventKey={index}>
          <Accordion.Header>{item.nome}</Accordion.Header>
          <Accordion.Body>
            {item?.servicos.map((itemServico, indexServ) => (

              <Card className="mb-15">
                <CardBody>
                  <Row>
                    <Col>
                      <h5>{itemServico.nome}</h5>
                      {itemServico?.tempoEstimado ? itemServico?.tempoEstimado + ' min' : ''}
                      {itemServico?.descricao}
                    </Col>

                    <Col className="text-center">
                      {(itemServico?.precoVariavel == 1) ? (<><span>A partir de: </span><br></br></>) : ''}

                      <span className='bold'>R$ {float2moeda(itemServico?.valor)}</span>
                    </Col>
                    <Col className="text-center">
                      <button className='btn btn-sm btn-success' onClick={() => handleClickAgendar(itemServico)}>Agendar</button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

            ))}


          </Accordion.Body>
        </Accordion.Item>

      ))}


    </Accordion>
  )
}

export default AcordionServicos;